import { createRef } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from '@vzmi/shp_shared_compo'
import SPBaseModule from '../../../../../lib/SPBaseModule'
import { pullLeft, pullRight } from '../../../../../styles/shared.css'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'
import { HyperLink } from '../../../../Common/Form'
import Modal from '../../../../Common/NewDashboard/Modal/Modal'
import Table from '../../../../Common/NewDashboard/Table/Table'
import LoadingSpinner from '../../../../Common/LoadingSpinner/LoadingSpinner'
import styles from './ReturnDetailDialog.css'

export const FIELD = {
  LISTING_ID: 'id',
  LISTING_NAME: 'name',
  RETURNED_AMOUNT: 'returnedAmount',
  RETURNED_QUANTITY: 'returnedQuantity'
}

const FIELD_MAP = {
  [FIELD.LISTING_ID]: '賣場編號',
  [FIELD.LISTING_NAME]: '賣場名稱',
  [FIELD.RETURNED_AMOUNT]: '退貨金額',
  [FIELD.RETURNED_QUANTITY]: '退貨數量'
}

const column = [
  {
    id: 'listingIdAndName',
    accessor: 'listingIdAndName',
    width: 291,
    headerClassName: cx(pullLeft, styles.col, styles.start),
    className: cx(pullLeft, styles.col, styles.start, styles.flexWrap),
    Header: `${FIELD_MAP[FIELD.LISTING_ID]}／${FIELD_MAP[FIELD.LISTING_NAME]}`,
    Cell: row => {
      const reason = _.get(row, 'original', {})
      const listingId = reason[FIELD.LISTING_ID]
      const listingName = reason[FIELD.LISTING_NAME]
      return (
        <>
          <p className={styles.listingId}>
            <HyperLink
              target='_blank'
              href={`/listing/query?id=${listingId}&idType=listing&page=1`}
            >
              {listingId}
            </HyperLink>
          </p>
          <p className={styles.listingName}>{listingName}</p>
        </>
      )
    }
  },
  {
    id: FIELD.RETURNED_AMOUNT,
    accessor: FIELD.RETURNED_AMOUNT,
    width: 115,
    Header: FIELD_MAP[FIELD.RETURNED_AMOUNT],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => dollarFormat(_.toNumber(row.value))
  },
  {
    id: FIELD.RETURNED_QUANTITY,
    accessor: FIELD.RETURNED_QUANTITY,
    width: 106,
    Header: FIELD_MAP[FIELD.RETURNED_QUANTITY],
    headerClassName: cx(pullRight, styles.col, styles.end),
    className: cx(pullRight, styles.col, styles.end),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  }
]

class ReturnDetailDialog extends SPBaseModule {
  constructor (props) {
    super(props)
    this.state = {
      visible: false,
      reasonId: null,
      reason: ''
    }
    this.infiniteScrollArea = createRef()
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      !prevState.visible &&
      this.state.visible &&
      // 首次產生時 component 時 ref 是空的
      this.infiniteScrollArea.current
    ) {
      // 重新進入 dialog 重置 scrollbar
      this.infiniteScrollArea.current.scrollTop = 0
    }
  }

  onOpen = (reasonId, reason) => this.setState({
    visible: true,
    reasonId,
    reason
  })

  onCancel = () => this.setState({ visible: false })

  onOk = () => this.onCancel()

  loadmore = async () => {
    const { updateReasons, reasonsMapping } = this.props
    const { reasonId } = this.state
    const offset = _.size(
      _.get(reasonsMapping, `${reasonId}.data`, [])
    )
    updateReasons(reasonId, offset)
  }

  render () {
    const { reasonsMapping } = this.props
    const {
      visible,
      isLoading,
      reasonId,
      reason
    } = this.state
    const { data, resultsTotal } = _.get(reasonsMapping, reasonId, {})
    const dataSize = _.size(data)
    return (
      <Modal
        title='退貨賣場'
        visible={visible}
        onOk={this.onOk}
        onCancel={this.onCancel}
        footer={null}
        className={styles.ReturnDetailDialog}
      >
        <p className={styles.reason}>
          退貨原因：
          {reason}
        </p>
        <Loader loaded={!isLoading}>
          <div
            id='InfiniteScroll'
            ref={this.infiniteScrollArea}
            className={styles.infiniteScrollArea}
          >
            <InfiniteScroll
              dataLength={dataSize}
              next={this.loadmore}
              hasMore={dataSize < resultsTotal}
              loader={<LoadingSpinner />}
              scrollableTarget='InfiniteScroll'
            >
              <Table
                sortable={false}
                resizable={false}
                showPagination={false}
                data={data}
                columns={column}
                pageSize={dataSize}
                className={styles.table}
                noBorder
              />
            </InfiniteScroll>
          </div>
        </Loader>
      </Modal>
    )
  }
}

export default ReturnDetailDialog
